export const FILE_TYPES = Object.freeze({
  THUMBNAIL: 'thumbnail',
  MODEL3D: 'model3D'
})
